import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var defaultSelection = {
  activeKey: null,
  isFocused: false,
  selectedKeys: []
};

function getSelection(database) {
  return database.selection;
}

function getActiveKeys(database) {
  if (!database.selection.activeKey) {
    // Default to first record, first column
    return [database.getFirstRecord().key, database.getFirstColumn().key];
  }

  return parseSelectionKey(database);
}

function getActiveRecordKey(database) {
  return getActiveKeys(database)[0];
}

function getActiveColumnKey(database) {
  return getActiveKeys(database)[1];
}

function activate(database) {
  for (var _len = arguments.length, keys = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    keys[_key - 1] = arguments[_key];
  }

  var activeKey = keys.length > 0 ? generateSelectionKey(keys) : database.selection.activeKey;
  return database.setSelection(_objectSpread({}, defaultSelection, {
    activeKey: activeKey,
    isFocused: false
  }));
}

function focus(database) {
  for (var _len2 = arguments.length, keys = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    keys[_key2 - 1] = arguments[_key2];
  }

  var activeKey = keys.length > 0 ? generateSelectionKey(keys) : database.selection.activeKey;
  return database.setSelection(_objectSpread({}, defaultSelection, {
    activeKey: activeKey,
    isFocused: true
  }));
}

function blur(database) {
  return database.setSelection(_objectSpread({}, defaultSelection, {
    activeKey: null,
    isFocused: false
  }));
}

function activateRecordBefore(database) {
  var _getActiveKeys = getActiveKeys(database),
      _getActiveKeys2 = _slicedToArray(_getActiveKeys, 2),
      recordKey = _getActiveKeys2[0],
      columnKey = _getActiveKeys2[1];

  var recordBefore = database.getRecordBefore(recordKey);

  if (recordBefore) {
    database.activate(recordBefore.key, columnKey);
  }
}

function activateRecordAfter(database) {
  var _getActiveKeys3 = getActiveKeys(database),
      _getActiveKeys4 = _slicedToArray(_getActiveKeys3, 2),
      recordKey = _getActiveKeys4[0],
      columnKey = _getActiveKeys4[1];

  var recordAfter = database.getRecordAfter(recordKey);

  if (recordAfter) {
    database.activate(recordAfter.key, columnKey).registerScrollRecordKey(recordAfter.key);
  }
}

function activateFirstRecord(database) {
  var columnKey = database.getActiveColumnKey();
  var records = database.getSortedRecords();
  var record = records[0];
  database.activate(record.key, columnKey);
}

function activateLastRecord(database) {
  var columnKey = database.getActiveColumnKey();
  var records = database.getSortedRecords();
  var record = records[records.length - 1];
  database.activate(record.key, columnKey).registerScrollRecordKey(record.key);
}

function activateColumnBefore(database) {
  var _getActiveKeys5 = getActiveKeys(database),
      _getActiveKeys6 = _slicedToArray(_getActiveKeys5, 2),
      recordKey = _getActiveKeys6[0],
      columnKey = _getActiveKeys6[1];

  var columnBefore = database.getColumnBefore(columnKey);

  if (columnBefore) {
    database.activate(recordKey, columnBefore.key);
  } else {
    // At beginning of record
    var column = database.getLastColumn();
    var record = database.getRecordBefore(recordKey);

    if (record) {
      database.activate(record.key, column.key);
    }
  }
}

function activateColumnAfter(database) {
  var _getActiveKeys7 = getActiveKeys(database),
      _getActiveKeys8 = _slicedToArray(_getActiveKeys7, 2),
      recordKey = _getActiveKeys8[0],
      columnKey = _getActiveKeys8[1];

  var columnAfter = database.getColumnAfter(columnKey);

  if (columnAfter) {
    database.activate(recordKey, columnAfter.key);
  } else {
    // At end of record
    var column = database.getFirstColumn();
    var record = database.getRecordAfter(recordKey);

    if (record) {
      database.activate(record.key, column.key);
    }
  }
}

function selectRecord(database, recordKey) {
  var columns = database.getSortedColumns();
  var firstColumnKey = columns[0].key;
  var selectedKeys = columns.map(function (column) {
    return generateSelectionKey([recordKey, column.key]);
  });
  return database.setSelection({
    activeKey: generateSelectionKey([recordKey, firstColumnKey]),
    selectedKeys: selectedKeys
  });
}

function selectColumn(database, columnKey) {
  var selectedKeys = database.getSortedRecords().map(function (record) {
    return generateSelectionKey([record.key, columnKey]);
  });
  return database.setSelection({
    activeKey: selectedKeys[0],
    selectedKeys: selectedKeys
  });
}

function selectAll(database) {
  var selectedKeys = [];
  database.getSortedColumns().forEach(function (column) {
    database.getSortedRecords().forEach(function (record) {
      selectedKeys.push(generateSelectionKey([record.key, column.key]));
    });
  });
  return database.setSelection({
    selectedKeys: selectedKeys
  });
}

function generateSelectionKey(keys) {
  return keys.join('_');
}

function parseSelectionKey(database) {
  return (database.selection.activeKey || '').split('_');
}

function isActive(database) {
  for (var _len3 = arguments.length, keys = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    keys[_key3 - 1] = arguments[_key3];
  }

  // If no key provided, return if the whole database is active
  if (keys.length === 0) {
    return Boolean(database.selection.activeKey);
  }

  return database.selection.activeKey === generateSelectionKey(keys);
}

function isFocused(database) {
  for (var _len4 = arguments.length, keys = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    keys[_key4 - 1] = arguments[_key4];
  }

  return database.selection.isFocused && database.isActive.apply(database, keys);
}

function isSelected(database) {
  for (var _len5 = arguments.length, keys = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    keys[_key5 - 1] = arguments[_key5];
  }

  return database.selection.selectedKeys.includes(generateSelectionKey(keys));
}

function isInSelectedKeys(database, key) {
  return database.selection.selectedKeys.some(function (keys) {
    return keys.includes(key);
  });
}

function isBlurred(database) {
  return database.selection.activeKey === null;
}

function getActive(database) {
  var _getActiveKeys9 = getActiveKeys(database),
      _getActiveKeys10 = _slicedToArray(_getActiveKeys9, 2),
      recordKey = _getActiveKeys10[0],
      columnKey = _getActiveKeys10[1];

  return {
    field: database.getField(recordKey, columnKey),
    record: database.getRecord(recordKey),
    column: database.getColumn(columnKey)
  };
}

export default {
  queries: {
    getSelection: getSelection,
    getActiveKeys: getActiveKeys,
    getActiveColumnKey: getActiveColumnKey,
    getActiveRecordKey: getActiveRecordKey,
    getActive: getActive,
    isActive: isActive,
    isFocused: isFocused,
    isSelected: isSelected,
    isBlurred: isBlurred,
    isInSelectedKeys: isInSelectedKeys
  },
  commands: {
    activate: activate,
    blur: blur,
    focus: focus,
    activateFirstRecord: activateFirstRecord,
    activateLastRecord: activateLastRecord,
    activateRecordBefore: activateRecordBefore,
    activateRecordAfter: activateRecordAfter,
    activateColumnBefore: activateColumnBefore,
    activateColumnAfter: activateColumnAfter,
    selectRecord: selectRecord,
    selectColumn: selectColumn,
    selectAll: selectAll
  }
};